import React from 'react';
import journal1 from '../../images/journals/1.png'
import journal2 from '../../images/journals/2.png'
import journal3 from '../../images/journals/3.png'
import journal4 from '../../images/journals/4.png'
import './style.css'

export default function Journal() {
    const journalData = [
        {
            id: 1,
            title: "Journal 2025",
            image: journal4,
            date: "March 15, 2024",
            url: "https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2025.pdf"
        },
        {
            id: 2,
            title: "Journal 2023",
            image: journal3,
            date: "March 10, 2024",
            url: "https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2023.pdf"
        },
        {
            id: 3,
            title: "Journal 2022",
            image: journal2,
            date: "March 5, 2024",
            url: "https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2022.pdf"
        },
        {
            id: 4,
            title: "Journal 2020",
            image: journal1,
            date: "February 28, 2024",
            url: "https://pub-2e62b0f5d6654391b41413db98565a70.r2.dev/2020.pdf"
        }
    ];

    return (
        <div className="journal-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="journal-title">
                            <h2>Our Journals</h2>
                            <p>Documenting our journey of social change and community impact</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {journalData.map((journal) => (
                        <div key={journal.id} className="col-lg-4 col-md-6 col-sm-12 col-12 custom-grid">
                            <div className="journal-card">
                                <div className="journal-image">
                                    <img src={journal.image} alt={journal.title} />
                                </div>
                                <div className="journal-content">
                                    {/* <div className="journal-date">{journal.date}</div> */}
                                    <div className="journal-title-row">
                                        <h3>{journal.title}</h3>
                                        <a href={journal.url} target="_blank" rel="noopener noreferrer" className="download-icon">
                                            <i className="fa fa-download"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}